export default {
    listagem_etiquetas: 'Listagem de etiquetas',
    etiqueta_nao_encontrada: 'Nenhuma etiqueta encontrada',
    etiqueta: 'Etiqueta',
    status: {
        disponivel: 'Disponível',
        cancelada: 'Cancelada',
        pendente: 'Pendente',
        usada: 'Usada'
    }
}